import * as React from "react"

import { cn } from "@/custolink-newdesign/lib/utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "cl:flex cl:field-sizing-content cl:min-h-16 cl:w-full cl:rounded-md cl:border cl:border-input cl:bg-transparent cl:px-3 cl:py-2 cl:text-base cl:shadow-xs cl:transition-[color,box-shadow] cl:outline-none cl:placeholder:text-muted-foreground cl:focus-visible:border-ring cl:focus-visible:ring-[3px] cl:focus-visible:ring-ring/50 cl:disabled:cursor-not-allowed cl:disabled:opacity-50 cl:aria-invalid:border-destructive cl:aria-invalid:ring-destructive/20 cl:md:text-sm cl:dark:bg-input/30 cl:dark:aria-invalid:ring-destructive/40",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
